import React from 'react';
import { StaticQuery, graphql, Link } from 'gatsby';
import Image from 'gatsby-image';

import './index.scss';
import { rhythm } from '../../utils/typography';

export const Bio = () => (
  <StaticQuery
    query={bioQuery}
    render={(data) => {
      const { author, social, introduction } = data.site.siteMetadata;

      return (
        <div className="bio" style={{ marginBottom: `${rhythm(1.5)}` }}>
          <div className="author">
            <div className="author-description">
              <div>
                <Image
                  className="author-image"
                  fixed={data.avatar.childImageSharp.fixed}
                  alt={author}
                  style={{
                    borderRadius: `100%`,
                    padding: 0,
                    margin: 0,
                  }}
                />
              </div>
              <div
                className="author-name"
                style={{ alignSelf: 'stretch', marginLeft: '1em' }}
              >
                {/* <span className="author-name-prefix">Written by</span> */}
                <Link to={'/about'} className="author-name-content">
                  <span>@{author}</span>
                </Link>
                <div className="author-introduction">{introduction}</div>
                {/* <p className="author-socials"> */}
                {/* {social.github && (
                    <a href={`https://github.com/${social.github}`}>github</a>
                  )} */}
                {/* {social.medium && (
                    <a href={`https://medium.com/${social.medium}`}>Medium</a>
                  )}
                  {social.twitter && (
                    <a href={`https://twitter.com/${social.twitter}`}>
                      Twitter
                    </a>
                  )}
                  {social.facebook && (
                    <a href={`https://www.facebook.com/${social.facebook}`}>
                      Facebook
                    </a>
                  )}
                  {social.linkedin && (
                    <a href={`https://www.linkedin.com/in/${social.linkedin}/`}>
                      LinkedIn
                    </a>
                  )} */}
                {/* </p> */}
              </div>
            </div>
          </div>
        </div>
      );
    }}
  />
);

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile.png/" }) {
      childImageSharp {
        fixed(width: 72, height: 72) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        introduction
        social {
          twitter
          github
          medium
          facebook
          linkedin
        }
      }
    }
  }
`;

export default Bio;
